import { cn } from '@/lib/classMerge'
import { Loader } from 'lucide-react'
import React from 'react'

const CircularLoading = ({ className }: { className?: string }) => (
  <div className={cn('flex items-center justify-center', className)}>
    <Loader className='animate-spin' />
  </div>
)

export default CircularLoading
